import {
  Component,
  Input,
} from '@angular/core';

import { DefaultModalComponent } from '../default-modal/default-modal.component';
import { BaseModalComponent } from '../_base-modal.component';


@Component({
  moduleId: module.id,
  selector: 'error-modal',
  templateUrl: 'error-modal.component.html',
  styleUrls: ['error-modal.component.scss'],
})
export class ErrorModalComponent extends BaseModalComponent {
  @Input() title: string;

}
